import { onWatcherCleanup, shallowRef, watch, type Ref } from "vue";

export const useStablePending = (
  isPending: Ref<boolean>,
  {
    showDelay = 250,
    minShowTime = 500,
  }: { showDelay?: number; minShowTime?: number } = {}
) => {
  const shouldShow = shallowRef(isPending.value);
  let showStartTime = shouldShow.value ? performance.now() : 0;

  watch(isPending, (nextValue) => {
    // Start pending - set delay timer
    if (nextValue) {
      const timeout = setTimeout(() => {
        shouldShow.value = true;
        showStartTime = performance.now();
      }, showDelay);

      onWatcherCleanup(() => clearTimeout(timeout));
      return;
    }

    if (shouldShow.value) {
      // Currently showing, check minimum time
      const elapsed = performance.now() - showStartTime;

      if (elapsed >= minShowTime) {
        // Minimum time met, hide immediately
        shouldShow.value = false;
        return;
      }

      // Need to wait for minimum time
      const remainingTime = minShowTime - elapsed;

      const timeout = setTimeout(() => {
        shouldShow.value = false;
      }, remainingTime);

      onWatcherCleanup(() => clearTimeout(timeout));
      return;
    }
  });

  return shouldShow;
};
